// Generated by genversion.
export const version = '2.28.0';
//# sourceMappingURL=version.js.map